import React, { useState } from 'react'
import { Button } from 'react-bootstrap'

import uploadIcon from '../../../imgs/upload.png'
import { uploadFile } from '../../../services/files'

export default function ReceiveShipments() {
  const [fileUploadMsg, setfileUploadMsg] = useState('')
  const [fetchEmailsMsg, setfetchEmailsMsg] = useState('')
  const [emailsMsg] = useState('')
  const [jobId] = useState('')
  const [emailsReady] = useState(false)
  const [emails, setEmails] = useState([])

  const uploadHandler = async e => {
    const file = e.target.files[0]
    console.log('🚀 - uploadHandler - file', file)
    const name = Date.now() + file.name

    try {
      const result = await uploadFile(file, name)

      console.log(result)

      if (result.key) {
        setfileUploadMsg('Success!')
        // sendToServer(result.Location)
      }
    } catch (error) {
      console.log('Error uploading file: ', error)
      setfileUploadMsg('Error! check console...')
      throw error
    }
  }

  // const sendToServer = async fileKey => {
  //   const payload = {
  //     body: { fileKey: fileKey },
  //   }

  //   try {
  //     const result = await API.post('myS2SApiv1', '/receiveshipments', payload)

  //     setjobId(result.JobId)

  //     let count = 20
  //     const btnEl = document.getElementById('fetch-btn')
  //     const interval = setInterval(() => {
  //       btnEl.innerText = count - 1
  //       count -= 1
  //     }, 1000)

  //     setTimeout(() => {
  //       setemailsReady(true)
  //       clearInterval(interval)
  //       btnEl.innerText = 'Get Emails'
  //     }, 20000)
  //   } catch (err) {
  //     console.log('Error in:' + err)
  //     throw err
  //   }
  // }

  const fetchEmails = async () => {
    const params = {
      bucket: 'textract-console-us-east-1-ace8e199-6f02-482a-a3f4-39b1ccf0cb52',
      download: true,
    }
    try {
      const fileURL = await Storage.get(`${jobId}.json`, params)
      fileURL.Body.text().then(string => {
        setEmails(Array.from(JSON.parse(string)))
      })
    } catch (err) {
      setfetchEmailsMsg(err)
      console.log(err)
    }
  }

  // const sendMails = async () => {
  //   const payload = {
  //     body: { emails: emails },
  //   }

  //   try {
  //     const result = await API.post('myS2SApiv1', '/receiveshipments', payload)
  //     console.log('🚀 - sendMails - result', result)
  //     setemailsMsg(result)
  //   } catch (err) {
  //     console.log('Error in:' + err)
  //     setemailsMsg(err)
  //     throw err
  //   }
  // }

  return (
    <section className='receive-shipments-section'>
      <h1>Receive Shipments</h1>
      <br />
      <div>
        <span style={{ color: 'red' }}>PAY ATTENTION:</span>
        <p>
          1. Make sure the document is clear and readable.
          <br />
          2. You can upload only: PNG / JPG / PDF files.
          <br />
          3. Once you uploaded the file successfully, wait for the &quot;Get Emails&quot; button to be ready.
          <br />
          4. If it didnt got the emails list one the first time, wait a few seconds and try again.
          <br />
        </p>
      </div>

      <img src={uploadIcon} alt='upload' onClick={() => document.getElementById('receive-shipment-input').click()} />
      <input type='file' id='receive-shipment-input' onChange={uploadHandler} />
      <br />

      <div>{fileUploadMsg}</div>

      <br />

      {fileUploadMsg && (
        <>
          <Button onClick={fetchEmails} disabled={!emailsReady} id='fetch-btn'>
            20
          </Button>
          <br />
          {fetchEmailsMsg}
        </>
      )}

      {emails.length > 0 && (
        <div className='receive-shipments-emails'>
          <h5>
            <span>{emails.length}</span> Mails will be sent to this Emails:
          </h5>
          {emails.map(email => email + ', ')}
          <br />
          <br />
          {/* <Button variant='danger' onClick={sendMails}>
            Send Mails
          </Button> */}
          <br />
          {emailsMsg}
        </div>
      )}
    </section>
  )
}
